module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"retryFiscalization":"Resend to fiscal system","contractSettings":"Contract Settings","hasWarranty":"Has Warranty","isForeign":"Is Foreign Client"},"al":{"retryFiscalization":"Ridergo Sistemit Fiskal","contractSettings":"Cilësimet e Kontratës","hasWarranty":"Ka Garanci","isForeign":"Klient i Huaj"}}')
  delete Component.options._Ctor
}
